

import { Component, Prop, Emit, Mixins } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import UserRightsMixin from '~/mixins/UserRightsMixin';

@Component
export default class ThemedButton extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {
    @Prop({ default: false }) readonly text!: boolean;
    @Prop({ default: undefined }) readonly outlined: boolean | undefined;
    @Prop({ default: false }) readonly block!: boolean;
    @Prop({ default: false }) readonly disabled!: boolean;
    @Prop({ default: false }) readonly small!: boolean;
    @Prop({ default: false }) readonly xSmall!: boolean;
    @Prop({ default: false }) readonly large!: boolean;
    @Prop({ default: false }) readonly icon!: boolean;
    @Prop({ default: undefined }) readonly tile!: boolean | undefined;
    @Prop({ default: '' }) readonly href!: string;
    @Prop({ default: '' }) readonly target!: string;
    @Prop({ default: '' }) readonly color!: string;
    @Prop({ default: '' }) readonly type!: string;
    @Prop({ default: '' }) readonly to!: string;
    // v-on prop is used by elements that need activation like a tooltip when
    // hovering on the button, or a dialog that opens on click
    @Prop() readonly vOn!: object;

    @Emit()
    click() {
        return 'click';
    }
    get getOutlined() {
        // if outlined boolean is given as a prop to the vue, use its value
        // else, outline button if dark mode is inactive and it's not an icon
        return typeof this.outlined !== 'undefined' ? this.outlined : !this.isDarkModeActive && !this.icon;
    }

    get getColor() {
        // if a color is defined return it. If it is falsy but no type is
        // specified, return it as is (falsy values are ignored by vuetify)
        if (this.color || !this.type) {
            return this.color;
        }
        // if no color was specified but there is a type, find the
        // associated color for the group
        switch (this.type) {
            case 'danger':
                return 'error';
            case 'get':
            case 'close':
                return 'primary';
        }
        return '';
    }

    get getTile() {
        // unless tile is specified, apply it if the button is an icon
        return typeof this.tile !== 'undefined' ? this.tile : this.icon;
    }
}
